var map = {
	"./courseData/courseData.router.js": "2011",
	"./dynamic/dynamic.router.js": "8eea",
	"./emerCase/emerCase.router.js": "8c20",
	"./enterpriseTrain/enterpriseTrain.router.js": "94d2",
	"./entrance/entrance.router.js": "a5fe",
	"./error/error.router.js": "bbc8",
	"./gpt/gpt.router.js": "decb",
	"./homeyj/homeyj.router.js": "992c",
	"./kbase/kbase.router.js": "bf6e",
	"./learn/learn.router.js": "d997",
	"./operationHomeWork/operationHomeWork.router.js": "e452c",
	"./personal/personal.router.js": "b843",
	"./staffTrain/staffTrain.router.js": "c09b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f700";